import { PureLightTheme } from "../../../styles/theme"
import { COLORS } from "../../../styles/variables"

export const BoxImageStyle = {
    width: 146,
    height: 100,
    position: 'relative',
    borderRadius: '8px',
    overflow: 'hidden',
}

export const IconButtonStyle = {
    position: 'absolute',
    top: 5,
    right: 5,
    backgroundColor: COLORS.WHITE,
    width: "28px",
    height: "28px",
}

export const LoadingRowStyle = {
    mt: 3,
    minHeight: 28,
}

export const BoxInputStyle = {
    width: "100%",
    height: "300px",
    border: `2px dashed ${COLORS.CERULEAN}`,
    borderRadius: "12px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "0.3s",
    [PureLightTheme.breakpoints.down("md")]: {
        height: "200px",
    },
}
